import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { network } from "../config";
// 创建 InjectedConnector 实例

const networks = [1];
const rpcs: any = {
  // 1: "https://rpc.ankr.com/eth",
  1: "https://rpc.ankr.com/eth/66c6ffb3891a28f203e105330784ef1cbed1d2194cecd0659ce3f8a51f4a3205",
  1337: "http://localhost:8545",
  11155111: "https://rpc.sepolia.org",
  5: "https://rpc.ankr.com/eth_goerli",
};

if ((network as any) != 1) {
  networks.push(network);
  // rpcs[network] =
}
const injectedConnector = new InjectedConnector({
  supportedChainIds: networks,
});

// 创建 WalletConnectConnector 实例
const walletconnectConnector = new WalletConnectConnector({
  rpc: rpcs,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
});

// 将 Connector 实例存储到一个数组中
export const connectors = {
  injected: injectedConnector,
  walletconnect: walletconnectConnector,
};

// console.log("connectors = ", connectors);
